<template>
  <van-popup class="add-game-van-popup" v-model="popupShow" position="bottom" get-container="body"
    :style="{ background: 'transparent', overflow: 'visible' }" :close-on-click-overlay="true" :z-index="3000"
    @closed="handlePopupClosed">
    <div class="add-game-popup" :class="{ 'is-dragging-lock': isDragging || pressActive }"
      @touchmove="handlePopupTouchMove">
      <div class="popup_header">
        <div class="popup_title">在玩游戏</div>
        <div class="popup_close" @click="close">
          <img :src="require('@/assets/image/icon/close.png')" alt="" />
        </div>
      </div>

      <div class="popup_body" ref="popupBody">
        <div v-if="isLoadingContent" class="popup_skeleton">
          <div class="skeleton_title"></div>
          <div class="skeleton_added_grid">
            <div v-for="item in 4" :key="item" class="skeleton_added_item">
              <div class="skeleton_icon"></div>
              <div class="skeleton_name"></div>
              <div class="skeleton_button"></div>
            </div>
          </div>
          <div class="skeleton_title skeleton_all_title"></div>
          <div v-for="item in 5" :key="`row-${item}`" class="skeleton_row">
            <div class="skeleton_icon"></div>
            <div class="skeleton_row_name"></div>
            <div class="skeleton_button"></div>
          </div>
        </div>

        <div v-else ref="popupScroll" class="popup_scroll" :style="{ overflowY: isDragging ? 'hidden' : 'auto' }"
          @scroll="handleScroll">
          <div id="letter-added" ref="letterAdded" class="added_anchor"></div>
          <div class="added_section" v-if="addedGameCards.length">
            <div class="section_title">已添加<span class="section_title_tip">(长按拖动排序)</span></div>
            <div class="added_grid">
              <div v-for="(item, index) in addedGameCards" :key="getGameId(item)"
                :class="['added_item', isDragging && draggingGameId === getGameId(item) && 'is-dragging', pressActive && pressGameId === getGameId(item) && 'is-pressing']"
                @touchstart.passive="recordDragStartPoint"
                @touchmove="handleItemTouchMove"
                @touchend="onPressEnd"
                @touchcancel="onPressEnd">
                <div class="added_icon_wrap"
                  @touchstart.stop.prevent="onLongPressStart(item, index, $event)"
                  @mousedown.stop.prevent="onLongPressStart(item, index, $event)"
                  @touchend.stop="onIconPressEnd(item)"
                  @touchcancel.stop="onIconPressEnd(item)"
                  @mouseup.stop="onIconPressEnd(item)"
                  @mouseleave="onMouseLeavePress"
                  @contextmenu.prevent.stop=""
                  @click.stop.prevent="">
                  <div class="added_icon" :style="{ backgroundImage: `url(${item.icon || fallbackIcon})` }"></div>
                </div>
                <div class="added_name">{{ item.name }}</div>
                <div :class="['added_btn', isAdded(item) ? 'is-added' : 'is-normal']" @click="toggleGameStatus(item)">
                  {{ isAdded(item) ? '已添加' : '添加' }}
                </div>
              </div>
            </div>
          </div>

          <div class="section_title all_games_title" v-if="groupedSections.length">全部游戏</div>

          <div v-for="section in groupedSections" :key="section.letter" :id="getLetterAnchorId(section.letter)"
            :ref="`letter-${section.letter}`" class="letter_section">
            <div class="section_title">{{ section.letter }}</div>
            <div v-for="item in section.list" :key="getGameId(item)" class="game_row">
              <div class="game_info" @click.stop="handleClick(item, 'all')">
                <img class="game_icon" :src="item.icon || fallbackIcon" alt="" />
                <div class="game_name">{{ item.name }}</div>
              </div>
              <div :class="['game_action_btn', isAdded(item) && 'is-added']" @click="toggleGameStatus(item)">
                {{ isAdded(item) ? '已添加' : '添加' }}
              </div>
            </div>
          </div>
          <div class="bottom_placeholder"></div>
        </div>

        <div v-if="!isLoadingContent && isDragging && draggingItem" class="added_drag_preview"
          :style="dragPreviewStyle">
          <div class="added_icon" :style="{ backgroundImage: `url(${draggingItem.icon || fallbackIcon})` }"></div>
          <div class="added_name">{{ draggingItem.name }}</div>
        </div>

        <div class="letter_sidebar" v-if="!isLoadingContent && letters.length">
          <div v-for="letter in letters" :key="letter"
            :class="['letter_item', letter === '已加' && 'is-added', activeLetter === letter && 'is-active']"
            @click="scrollToLetter(letter)">
            <template v-if="letter === '已加'">
              <div class="letter_two_line">
                <span>已</span>
                <span>加</span>
              </div>
            </template>
            <template v-else>
              <span>{{ letter }}</span>
            </template>
          </div>
        </div>
      </div>

      <div class="bubble-pop" v-if="!hasSelectedCommunityGame && !isMember">
        <div class="bubble-pop-title">选择并添加你感兴趣的游戏</div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { mapState } from 'vuex'
import { roleGameList, myGame } from '@/api/user'

export default {
  name: 'AddGamePopup',
  props: {
    isMember: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      popupShow: false,
      fallbackIcon: require('@/assets/image/member/1.png'),
      loading: false,
      isLoadingContent: false,
      gameMapByLetter: {},
      activeLetter: '',
      mygameList: [],
      initialAddedIds: [],
      localAddedIds: [],
      hasChanged: false,
      lastScrollTop: 0,
      lastScrollHeight: 0,
      scrollViewHeight: 0,
      letterAnchorTops: [],
      measurePending: false,
      isDragging: false,
      draggingGameId: null,
      dragItemRects: [],
      dragContainerRect: null,
      dragStartPoint: null,
      dragX: 0,
      dragY: 0,
      hasReordered: false,
      newIndex: '',
      oldIndex: '',
      longPressTimer: null,
      justDragged: false,
      boundDragMove: null,
      boundDragEnd: null,
      boundPressMoveGuard: null,
      boundContextMenuGuard: null,
      pressActive: false,
      pressGameId: null,
      pressStartPoint: null,
      pressIndex: -1,
      pressItem: null,
      pressStartedAt: 0,
    }
  },
  computed: {
    ...mapState({
      selectedCommunityGame: state => state.user.selectedCommunityGame,
    }),
    hasSelectedCommunityGame() {
      const game = this.selectedCommunityGame
      if (!game || typeof game !== 'object') return false
      return !!(game.game_id || game.id)
    },
    groupedSections() {
      return Object.keys(this.gameMapByLetter).map(letter => ({
        letter,
        list: this.gameMapByLetter[letter] || []
      }))
    },
    letters() {
      return ['已加', ...this.groupedSections.map(item => item.letter)]
    },
    addedIds() {
      return this.localAddedIds
    },
    addedGameCards() {
      return this.mygameList
    },
    draggingItem() {
      return this.mygameList.find(item => this.getGameId(item) === this.draggingGameId)
    },
    dragPreviewStyle() {
      return {
        transform: `translate3d(${this.dragX}px, ${this.dragY}px, 0)`
      }
    },
    logged() {
      return this.$store.getters.logged
    },
  },
  watch: {
    gameMapByLetter() {
      this.scheduleMeasureAnchors()
    },
    mygameList() {
      this.scheduleMeasureAnchors()
    }
  },
  beforeDestroy() {
    this.clearLongPressTimer()
    this.unbindPressMoveGuard()
    this.unbindContextMenuGuard()
    this.unbindDocumentDragEvents()
  },
  methods: {
    getTouchPoint(event) {
      const touch = (event && event.touches && event.touches[0])
        || (event && event.changedTouches && event.changedTouches[0])
        || null
      if (touch) {
        const x = typeof touch.clientX === 'number' ? touch.clientX : touch.pageX
        const y = typeof touch.clientY === 'number' ? touch.clientY : touch.pageY
        if (typeof x === 'number' && typeof y === 'number') return { x, y }
      }
      if (event && typeof event.clientX === 'number') {
        return { x: event.clientX, y: event.clientY }
      }
      return null
    },
    recordDragStartPoint(event) {
      this.dragStartPoint = this.getTouchPoint(event)
    },
    clearLongPressTimer() {
      if (this.longPressTimer) {
        clearTimeout(this.longPressTimer)
        this.longPressTimer = null
      }
    },
    // 弹层内：长按/拖动时锁滚动；平时只阻止冒泡，保证列表可滚
    handlePopupTouchMove(event) {
      if (this.isDragging || this.pressActive) {
        if (event && event.cancelable && event.preventDefault) event.preventDefault()
        event && event.stopPropagation && event.stopPropagation()
        return
      }
      event && event.stopPropagation && event.stopPropagation()
    },
    bindContextMenuGuard() {
      this.unbindContextMenuGuard()
      this.boundContextMenuGuard = (event) => {
        if (event && event.preventDefault) event.preventDefault()
        if (event && event.stopPropagation) event.stopPropagation()
        return false
      }
      document.addEventListener('contextmenu', this.boundContextMenuGuard, true)
      document.addEventListener('selectstart', this.boundContextMenuGuard, true)
    },
    unbindContextMenuGuard() {
      if (!this.boundContextMenuGuard) return
      document.removeEventListener('contextmenu', this.boundContextMenuGuard, true)
      document.removeEventListener('selectstart', this.boundContextMenuGuard, true)
      this.boundContextMenuGuard = null
    },
    bindPressMoveGuard() {
      this.unbindPressMoveGuard()
      this.boundPressMoveGuard = (event) => {
        if (!this.pressActive || this.isDragging) return
        if (event && event.cancelable && event.preventDefault) event.preventDefault()
        const point = this.getTouchPoint(event)
        if (point) this.dragStartPoint = point
        // 触屏长按前移动超阈值时取消，避免和页面滑动冲突。
        // 鼠标允许轻微移动，避免 PC 端长按被过早取消。
        if (event && event.type === 'touchmove' && this.longPressTimer && point && this.pressStartPoint) {
          const dx = point.x - this.pressStartPoint.x
          const dy = point.y - this.pressStartPoint.y
          // 移动端手指抖动更大，阈值略放宽
          if (dx * dx + dy * dy > 100) {
            this.cancelPress()
          }
        }
      }
      document.addEventListener('touchmove', this.boundPressMoveGuard, { passive: false, capture: true })
      document.addEventListener('mousemove', this.boundPressMoveGuard, { passive: false, capture: true })
    },
    unbindPressMoveGuard() {
      if (!this.boundPressMoveGuard) return
      document.removeEventListener('touchmove', this.boundPressMoveGuard, true)
      document.removeEventListener('mousemove', this.boundPressMoveGuard, true)
      this.boundPressMoveGuard = null
    },
    bindDocumentDragEvents() {
      this.unbindDocumentDragEvents()
      this.boundDragMove = (event) => this.handleDragMove(event)
      this.boundDragEnd = () => this.finishDrag()
      document.addEventListener('touchmove', this.boundDragMove, { passive: false, capture: true })
      document.addEventListener('touchend', this.boundDragEnd, { capture: true })
      document.addEventListener('touchcancel', this.boundDragEnd, { capture: true })
      document.addEventListener('mousemove', this.boundDragMove, { passive: false, capture: true })
      document.addEventListener('mouseup', this.boundDragEnd, { capture: true })
    },
    unbindDocumentDragEvents() {
      if (this.boundDragMove) {
        document.removeEventListener('touchmove', this.boundDragMove, true)
        document.removeEventListener('mousemove', this.boundDragMove, true)
        this.boundDragMove = null
      }
      if (this.boundDragEnd) {
        document.removeEventListener('touchend', this.boundDragEnd, true)
        document.removeEventListener('touchcancel', this.boundDragEnd, true)
        document.removeEventListener('mouseup', this.boundDragEnd, true)
        this.boundDragEnd = null
      }
    },
    onLongPressStart(item, index, event) {
      // 必须 preventDefault，才能在 iOS/Android 模拟器抑制长按系统菜单
      if (event && event.cancelable && event.preventDefault) event.preventDefault()
      const point = this.getTouchPoint(event)
      this.dragStartPoint = point
      this.pressActive = true
      this.pressGameId = this.getGameId(item)
      this.pressItem = item
      this.pressIndex = index
      this.pressStartPoint = point
      this.pressStartedAt = Date.now()
      this.clearLongPressTimer()
      this.bindContextMenuGuard()
      this.bindPressMoveGuard()
      // PC 和移动端均长按后进入拖动，短按则保持原点击行为
      this.longPressTimer = setTimeout(() => {
        this.longPressTimer = null
        if (!this.pressActive) return
        this.startDrag(this.pressItem, this.pressIndex)
      }, 350)
    },
    cancelPress() {
      this.pressActive = false
      this.pressGameId = null
      this.pressItem = null
      this.pressIndex = -1
      this.pressStartPoint = null
      this.pressStartedAt = 0
      this.clearLongPressTimer()
      this.unbindPressMoveGuard()
      if (!this.isDragging) this.unbindContextMenuGuard()
    },
    onMouseLeavePress() {
      // 拖动中鼠标移出图标不应结束拖动，交给 document mouseup
      if (this.isDragging) return
      this.cancelPress()
    },
    // 图标松手：短按手动触发点击（因 touchstart 已 preventDefault，原生 click 不会触发）
    onIconPressEnd(item) {
      if (this.isDragging) {
        this.finishDrag()
        return
      }
      const elapsed = this.pressStartedAt ? (Date.now() - this.pressStartedAt) : 0
      const isShortTap = this.pressActive && !!this.longPressTimer && elapsed < 350
      this.cancelPress()
      if (isShortTap && item) {
        this.handleClick(item, 'added')
      }
    },
    onPressEnd() {
      if (this.isDragging) {
        this.finishDrag()
        return
      }
      this.cancelPress()
    },
    handleItemTouchMove(event) {
      if (this.isDragging) {
        if (event && event.cancelable && event.preventDefault) event.preventDefault()
        this.handleDragMove(event)
        return
      }
      if (this.pressActive && event && event.cancelable && event.preventDefault) {
        event.preventDefault()
      }
      const point = this.getTouchPoint(event)
      if (this.longPressTimer && point && this.pressStartPoint) {
        const dx = point.x - this.pressStartPoint.x
        const dy = point.y - this.pressStartPoint.y
        if (dx * dx + dy * dy > 100) {
          this.cancelPress()
        }
      }
    },
    refreshDragItemRects() {
      const bodyEl = this.$refs.popupBody
      if (!bodyEl) return
      const items = bodyEl.querySelectorAll('.added_item')
      this.dragItemRects = Array.from(items).map(el => el.getBoundingClientRect())
      this.dragContainerRect = bodyEl.getBoundingClientRect()
    },
    startDrag(item, index) {
      if (!this.pressActive || this.isDragging || !item) return
      const point = this.dragStartPoint || this.pressStartPoint
      if (!point) return
      this.unbindPressMoveGuard()
      this.bindContextMenuGuard()
      this.oldIndex = index
      this.newIndex = index
      this.draggingGameId = this.getGameId(item)
      this.hasReordered = false
      this.refreshDragItemRects()
      if (!this.dragItemRects.length || !this.draggingGameId) {
        this.cancelPress()
        return
      }
      this.updateDragPreviewPosition(point)
      this.isDragging = true
      this.bindDocumentDragEvents()
    },
    handleDragMove(event) {
      if (!this.isDragging) return
      if (event && event.cancelable && event.preventDefault) event.preventDefault()
      const point = this.getTouchPoint(event)
      if (!point) return
      this.dragStartPoint = point
      this.updateDragPreviewPosition(point)
      const targetIndex = this.getClosestDragIndex(point)
      if (targetIndex < 0) return
      const currentIndex = this.mygameList.findIndex(item => this.getGameId(item) === this.draggingGameId)
      if (currentIndex === -1 || currentIndex === targetIndex) return
      const nextList = [...this.mygameList]
      const [draggingItem] = nextList.splice(currentIndex, 1)
      nextList.splice(targetIndex, 0, draggingItem)
      this.mygameList = nextList
      this.hasReordered = true
      this.newIndex = targetIndex
      this.$nextTick(() => {
        this.refreshDragItemRects()
      })
    },
    updateDragPreviewPosition(point) {
      const containerRect = this.dragContainerRect
      this.dragX = point.x - (containerRect ? containerRect.left : 0)
      this.dragY = point.y - (containerRect ? containerRect.top : 0)
    },
    getClosestDragIndex(point) {
      if (!this.dragItemRects.length) return -1
      let closestIndex = 0
      let closestDistance = Infinity
      this.dragItemRects.forEach((rect, index) => {
        const centerX = rect.left + rect.width / 2
        const centerY = rect.top + rect.height / 2
        const deltaX = point.x - centerX
        const deltaY = point.y - centerY
        const distance = deltaX * deltaX + deltaY * deltaY
        if (distance < closestDistance) {
          closestDistance = distance
          closestIndex = index
        }
      })
      this.newIndex = closestIndex
      return closestIndex
    },
    finishDrag() {
      this.clearLongPressTimer()
      this.unbindPressMoveGuard()
      this.unbindDocumentDragEvents()
      this.unbindContextMenuGuard()
      this.pressActive = false
      this.pressGameId = null
      this.pressItem = null
      this.pressIndex = -1
      this.pressStartPoint = null
      this.pressStartedAt = 0
      if (!this.isDragging) return
      if (this.oldIndex !== this.newIndex) {
        this.persistMyGameList()
      }
      const changed = this.hasReordered
      this.isDragging = false
      this.draggingGameId = null
      this.dragItemRects = []
      this.dragContainerRect = null
      this.dragStartPoint = null
      this.dragX = 0
      this.dragY = 0
      this.hasReordered = false
      this.justDragged = true
      setTimeout(() => {
        this.justDragged = false
      }, 200)
      if (changed) {
        this.hasChanged = true
        this.persistMyGameList()
        this.$emit('reordered', {
          games: [...this.mygameList],
          gameIds: this.mygameList.map(item => this.getGameId(item)).filter(Boolean)
        })
      }
      this.scheduleMeasureAnchors()
    },
    getGameId(item) {
      return item && (item.game_id || item.id)
    },
    getPlayingGameStorageKey() {
      return 'member:playing-games'
    },
    normalizePlayingGames(games) {
      const gameMap = new Map()
        ; (Array.isArray(games) ? games : []).forEach(item => {
          const gameId = this.getGameId(item)
          if (gameId && !gameMap.has(String(gameId))) {
            gameMap.set(String(gameId), { ...item })
          }
        })
      return Array.from(gameMap.values())
    },
    persistMyGameList() {
      const storageKey = this.getPlayingGameStorageKey()
      if (!storageKey) return
      localStorage.setItem(storageKey, JSON.stringify(this.mygameList.map(item => ({ ...item }))))
    },
    hasPlayingGameCache(storageKey) {
      if (!storageKey) return false
      try {
        return Array.isArray(JSON.parse(localStorage.getItem(storageKey) || 'null'))
      } catch (e) {
        return false
      }
    },
    async getMyGame() {
      const storageKey = this.getPlayingGameStorageKey()
      let games = []
      try {
        games = JSON.parse(localStorage.getItem(storageKey) || 'null') || []
      } catch (e) {
        games = []
      }
      if (storageKey && !this.hasPlayingGameCache(storageKey) && this.logged) {
        const playedGames = await this.getUserPlayedGames()
        if (playedGames) {
          games = playedGames
          localStorage.setItem(storageKey, JSON.stringify(playedGames))
        }
      }
      const list = this.normalizePlayingGames(games)
      this.mygameList = list
      const ids = list.map(item => this.getGameId(item)).filter(Boolean)
      this.initialAddedIds = ids
      this.localAddedIds = [...ids]
    },
    getLetterAnchorId(letter) {
      return `letter-${letter}`
    },
    async getGameList() {
      if (this.loading) return
      this.loading = true
      try {
        const { code, data } = await roleGameList()
        if (code == 200 && data) {
          this.gameMapByLetter = data
        }
      } finally {
        this.loading = false
      }
    },
    async open() {
      this.hasChanged = false
      this.activeLetter = '已加'
      this.isLoadingContent = true
      this.popupShow = true
      try {
        await Promise.all([
          this.getMyGame(),
          this.getGameList(),
        ])
      } finally {
        this.isLoadingContent = false
        this.$nextTick(() => {
          this.scheduleMeasureAnchors()
          this.scrollToLetter('已加')
        })
      }
    },
    close() {
      this.popupShow = false
    },
    handlePopupClosed() {
      this.finishDrag()
      this.$emit('closed', {
        changed: this.hasChanged
      })
      this.hasChanged = false
    },
    isAdded(item) {
      return this.addedIds.includes(this.getGameId(item))
    },
    scrollToLetter(letter) {
      this.activeLetter = letter
      const scrollEl = this.$refs.popupScroll
      if (!scrollEl) return
      this.$nextTick(() => {
        let targetEl = null
        if (letter === '已加') {
          targetEl = this.$refs.letterAdded
        } else {
          const refs = this.$refs[`letter-${letter}`]
          targetEl = Array.isArray(refs) ? refs[0] : refs
        }
        if (targetEl && scrollEl) {
          scrollEl.scrollTop = targetEl.offsetTop
        }
      })
    },
    handleScroll(e) {
      const scrollTop = e && e.target && typeof e.target.scrollTop === 'number' ? e.target.scrollTop : 0
      const scrollHeight = e && e.target && typeof e.target.scrollHeight === 'number' ? e.target.scrollHeight : 0
      this.lastScrollTop = scrollTop
      this.lastScrollHeight = scrollHeight
      this.updateActiveLetterByScroll(scrollTop, scrollHeight)
    },
    scheduleMeasureAnchors() {
      if (this.measurePending) return
      this.measurePending = true
      this.$nextTick(() => {
        setTimeout(() => {
          this.measurePending = false
          this.measureAnchorTops()
        }, 30)
      })
    },
    measureAnchorTops() {
      if (!this.popupShow) return
      const scrollEl = this.$refs.popupScroll
      if (!scrollEl) return
      const scrollRect = scrollEl.getBoundingClientRect()
      if (!scrollRect || !scrollRect.height) return
      this.scrollViewHeight = scrollRect.height
      const nextTops = []
      const addedEl = this.$refs.letterAdded
      if (addedEl) {
        const addedRect = addedEl.getBoundingClientRect()
        nextTops.push({
          letter: '已加',
          top: addedRect.top - scrollRect.top + (this.lastScrollTop || 0),
        })
      }
      this.groupedSections.forEach(section => {
        const refs = this.$refs[`letter-${section.letter}`]
        const el = Array.isArray(refs) ? refs[0] : refs
        if (!el) return
        const rect = el.getBoundingClientRect()
        nextTops.push({
          letter: section.letter,
          top: rect.top - scrollRect.top + (this.lastScrollTop || 0),
        })
      })
      nextTops.sort((a, b) => a.top - b.top)
      this.letterAnchorTops = nextTops
      this.updateActiveLetterByScroll(this.lastScrollTop || 0, this.lastScrollHeight || 0)
    },
    updateActiveLetterByScroll(scrollTop, scrollHeight) {
      if (!this.letterAnchorTops.length) return
      const resolvedScrollHeight = Number(scrollHeight || this.lastScrollHeight || 0)
      const resolvedViewHeight = Number(this.scrollViewHeight || 0)
      if (resolvedScrollHeight > 0 && resolvedViewHeight > 0) {
        const maxScrollTop = Math.max(0, resolvedScrollHeight - resolvedViewHeight)
        if (Number(scrollTop || 0) >= maxScrollTop - 6) {
          const last = this.letterAnchorTops[this.letterAnchorTops.length - 1]
          if (last && last.letter && last.letter !== this.activeLetter) {
            this.activeLetter = last.letter
          }
          return
        }
      }
      const offsetTop = 18
      const target = Number(scrollTop || 0) + offsetTop
      let nextLetter = this.letterAnchorTops[0].letter
      for (let i = 0; i < this.letterAnchorTops.length; i += 1) {
        const item = this.letterAnchorTops[i]
        if (target >= item.top) {
          nextLetter = item.letter
        } else {
          break
        }
      }
      if (nextLetter && nextLetter !== this.activeLetter) {
        this.activeLetter = nextLetter
      }
    },
    toggleGameStatus(item) {
      const gameId = this.getGameId(item)
      if (!gameId) return
      if (this.isAdded(item)) {
        this.$toast('删除成功')
        this.hasChanged = true
        this.localAddedIds = this.localAddedIds.filter(id => id !== gameId)
        this.initialAddedIds = this.initialAddedIds.filter(id => id !== gameId)
        this.mygameList = this.mygameList.filter(game => this.getGameId(game) !== gameId)
        this.persistMyGameList()
        this.$emit('removed', item)
        return
      }
      if (this.initialAddedIds.includes(gameId)) {
        this.localAddedIds = [...this.localAddedIds, gameId]
        return
      }
      this.$toast('添加成功')
      this.hasChanged = true
      this.localAddedIds = [...this.localAddedIds, gameId]
      this.initialAddedIds = [...this.initialAddedIds, gameId]
      this.mygameList = [item, ...this.mygameList.filter(game => this.getGameId(game) !== gameId)]
      this.persistMyGameList()
      this.$emit('added', item)
    },
    handleClick(item, type) {
      if (this.isMember) return
      if (this.justDragged || this.isDragging) return
      if (type === 'all' && !this.isAdded(item)) {
        this.toggleGameStatus(item)
      }
      this.$store.commit('setSelectedCommunityGame', item)
      this.$emit('getGameSheQu', item)
      this.close()
    },
    async getUserPlayedGames() {
      const { code, data } = await myGame({
        limit: 999
      })
      if (code == 200) {
        return this.normalizePlayingGames(data && data.list)
      }
      return null
    }
  }
}
</script>

<style lang="scss" scoped>
.add-game-van-popup {
  overflow: visible !important;
}

.add-game-popup {
  width: 100%;
  height: 80vh;
  background: #ffffff;
  border-radius: 0.7rem 0.7rem 0 0;
  padding: 0.95rem 0.75rem 0.6rem;
  box-sizing: border-box;
  position: relative;
  overflow: visible;

  &.is-dragging-lock {
    touch-action: none;
    user-select: none;
    -webkit-user-select: none;
    -webkit-touch-callout: none;
  }
}

.bubble-pop {
  height: 1.9rem;
  background: rgba(249, 251, 255, 1);
  border-radius: 0.4rem;
  position: absolute;
  left: 0.8rem;
  top: -2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem 0.5rem;

  &::after {
    content: '';
    position: absolute;
    left: 1.25rem;
    bottom: -0.525rem;
    width: 0;
    height: 0;
    border-left: 1.2rem solid transparent;
    border-right: 1.2rem solid transparent;
    border-top: 0.8rem solid rgba(249, 251, 255, 1);
  }
}

.bubble-pop-title {
  font-size: 0.7rem;
  color: #1d1d1d;
  white-space: nowrap;
}

.popup_header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.7rem;
}

.popup_title {
  color: #1d1d1d;
  font-size: 0.8rem;
  font-weight: 700;
}

.popup_close {
  position: absolute;
  right: 0;
  top: -0.25rem;
  width: 0.75rem;
  height: 0.75rem;

  img {
    width: 100%;
    height: 100%;
  }
}

.popup_body {
  position: relative;
  height: calc(100% - 1.8rem);
}

.popup_skeleton {
  height: 100%;
  padding-right: 1.1rem;
  box-sizing: border-box;
}

.skeleton_title,
.skeleton_icon,
.skeleton_name,
.skeleton_button,
.skeleton_row_name {
  background: linear-gradient(90deg, #f2f2f2 25%, #e8e8e8 50%, #f2f2f2 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.2s ease-in-out infinite;
}

.skeleton_title {
  width: 4.5rem;
  height: 0.7rem;
  margin-bottom: 0.75rem;
  border-radius: 0.2rem;
}

.skeleton_added_grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  margin-bottom: 1rem;
}

.skeleton_added_item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.skeleton_icon {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.6rem;
}

.skeleton_name {
  width: 2.5rem;
  height: 0.6rem;
  margin-top: 0.3rem;
  border-radius: 0.15rem;
}

.skeleton_button {
  width: 2.6rem;
  height: 1rem;
  margin-top: 0.3rem;
  border-radius: 0.55rem;
}

.skeleton_all_title {
  margin-top: 1rem;
}

.skeleton_row {
  display: flex;
  align-items: center;
  height: 2.5rem;
  margin-bottom: 0.75rem;
}

.skeleton_row_name {
  flex: 1;
  height: 0.7rem;
  margin: 0 0.6rem;
  border-radius: 0.2rem;
}

@keyframes skeleton-shimmer {
  from {
    background-position: 100% 0;
  }

  to {
    background-position: -100% 0;
  }
}

.added_anchor {
  width: 100%;
  height: 0.05rem;
}

.popup_scroll {
  height: 100%;
  padding-right: 1.1rem;
  box-sizing: border-box;
  overflow-y: auto;

  &::-webkit-scrollbar {
    display: none;
  }
}

.section_title {
  margin-bottom: 0.75rem;
  color: #1d1d1d;
  font-size: 0.7rem;
  font-weight: 700;
  line-height: 1;
}

.section_title_tip {
  font-size: 0.5rem;
  color: #8e8e8e;
  margin-left: 0.5rem;
}

.all_games_title {
  margin-top: 1rem;
}

.added_section {
  margin-bottom: 0.75rem;
}

.added_grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.75rem 0;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

.added_item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  transition: transform 0.15s ease, opacity 0.15s ease;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;

  &.is-dragging {
    opacity: 0.25;
  }

  &.is-pressing {
    touch-action: none;
  }
}

.added_icon_wrap {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.6rem;
  touch-action: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  overflow: hidden;
}

.added_icon,
.game_icon {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.6rem;
  object-fit: cover;
}

.added_icon {
  display: block;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  pointer-events: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
}

.added_drag_preview {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1000;
  width: 3.75rem;
  margin-left: -1.875rem;
  margin-top: -1.75rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  pointer-events: none;
  opacity: 0.92;
  transform-origin: center;
  will-change: transform;

  .added_icon {
    box-shadow: 0 0.25rem 0.6rem rgba(0, 0, 0, 0.2);
    transform: scale(1.08);
  }
}

.added_name {
  width: 3.75rem;
  margin-top: 0.3rem;
  color: #1d1d1d;
  font-size: 0.6rem;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
}

.added_btn,
.game_action_btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.6rem;
  height: 1rem;
  margin-top: 0.3rem;
  border-radius: 0.55rem;
  background: #f0f0f0;
  color: #1d1d1d;
  font-size: 0.6rem;
}

.added_btn.is-added,
.game_action_btn.is-added {
  background: #f0f0f0;
  color: #8e8e8e;
}

.letter_section {
  margin-bottom: 0.65rem;
}

.letter_section .section_title {
  margin-top: 0.9rem;
  margin-bottom: 0.6rem;
  font-size: 0.8rem;
}

.game_row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.75rem 0 0;
  margin-bottom: 0.75rem;
}

.game_info {
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1;
}

.game_name {
  margin-top: 0;
  margin-left: 0.6rem;
  padding-right: 0.5rem;
  color: #1d1d1d;
  font-size: 0.7rem;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.game_action_btn {
  margin-top: 0;
}

.letter_sidebar {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.3rem;
}

.letter_item {
  width: 0.7rem;
  height: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1d1d1d;
  font-size: 0.6rem;
  border-radius: 0.1rem;
  line-height: 1;
  cursor: pointer;
}

.letter_item.is-added {
  height: 1.5rem;
}

.letter_two_line {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0.25rem 0;
  width: 100%;
  height: 1.5rem;
}

.letter_two_line span {
  font-size: 0.5rem;
  line-height: 0.65rem;
}

.letter_item.is-active {
  background: #ffe399;
  color: #1d1d1d;
}

.bottom_placeholder {
  height: 0.5rem;
}
</style>
